// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BAZAAR_RESERVED = "Rezervovan\u00e9";
